<template>
    <div class="adv-box zy-list">
        <div class="adv-top-box">
            <Breadcrumb></Breadcrumb>
            <div class="adv-content-box">
                <div>
                    <img src="../../assets/images/advance_img1.png">
                </div>
                <h3>ADVANCE BATCH QUERY</h3>
                <h4>各学校提前批数据一键查询</h4>
            </div>
        </div>
        <div class="adv-frame-box">
            <div>
                <div class="adv-frame-title"><span></span>提前批查询</div>
                <el-form :inline="true" :model="form" ref="form" class="adv-form-inline" :rules="rules" label-position="right" label-width="115px">
                    <el-form-item label="学校名称：" prop="scl_id" class="adv-form-item">
                        <el-select v-model="form.scl_id" filterable remote clearable :remote-method="getSearchSchoolListHandler" :loading="loading" reserve-keyword placeholder="请输入学校" popper-class="adv-select">
                            <el-option v-for="item in school_list" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="科目类型：" prop="local_type_id">
                        <el-button v-for="(item, index) in subject_list" :class="active_index === index ? 'active-batch':''" @click="changeSubject(index)">{{item.name}}</el-button>
                    </el-form-item>
                    <el-form-item label="年份：" prop="year">
                        <el-select v-model="form.year" popper-class="adv-select">
                            <el-option v-for="(item, index) in year_list" :label="item.year" :value="item.year"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="招生类型：" prop="zslx">
                        <el-select v-model="form.zslx" clearable popper-class="adv-select" placeholder="请选择招生类型">
                            <el-option v-for="(item, index) in type_list" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="批次类型：" prop="local_batch_id">
                       <el-button v-for="(item, index) in batch_list" :class="active_index1 === index ? 'active-batch':''" @click="changeBatch(index)">{{item.name}}</el-button>
                    </el-form-item>
                    </el-form-item>
                    <el-button type="primary" @click="getSchoolAdvanceSubmit" class="adv-btn-submit">查询提前批</el-button>
                </el-form>
            </div>
            <template v-if="show">
                <div class="adv-frame-title"><span></span>查询结果</div>
                <div class="school-detail-nav">
                    <el-table :data="adv_list" style="width: 100%" border :span-method="objectSpanMethod">
                        </el-table-column>
                        <el-table-column label="学校名称">
                            <template slot-scope="scope">
                                <div class="adv-title" style="font-size: 16px">{{scope.row.college_code?'[' + scope.row.college_code + ']':''}}{{scope.row.scl_name}}</div>
                                {{scope.row.scl_remark}}
                            </template>
                        </el-table-column>
                        <el-table-column label="招生类型" width="170">
                            <template slot-scope="scope">
                                 <div class="adv-title">{{type_obj[scope.row.zslx]}}</div>
                                计划招生总数：{{scope.row.scl_plan_num?scope.row.scl_plan_num:'-'}}<br>
                                最低分：{{scope.row.scl_score_min?scope.row.scl_score_min:'-'}}<br>
                                位次：{{scope.row.scl_section_min?scope.row.scl_section_min:'-'}}
                            </template>
                        </el-table-column>
                        <el-table-column label="专业">
                            <template slot-scope="scope">
                                <div class="adv-title">{{scope.row.plan_name}}</div>
                                {{scope.row.plan_remark?scope.row.plan_remark:''}}{{!scope.row.plan_remark && scope.row.sp_length?'学制：' + scope.row.sp_length + '年':''}}{{!scope.row.plan_remark && scope.row.tuition?'学费：' + scope.row.tuition + '元/年':''}}
                            </template>
                        </el-table-column>
                        <el-table-column label="计划招生" width="110">
                            <template slot-scope="scope">
                                {{scope.row.sp_num?scope.row.sp_num:'-'}}
                            </template>
                        </el-table-column>
                        <el-table-column label="最低分" width="94">
                            <template slot-scope="scope">
                                {{scope.row.sp_score_min?scope.row.sp_score_min:'-'}}
                            </template>
                        </el-table-column>
                        <el-table-column label="位次" width="80">
                            <template slot-scope="scope">
                                {{scope.row.sp_section_min?scope.row.sp_section_min:'-'}}
                            </template>
                        </el-table-column>
                        <el-table-column label="学制" width="80">
                            <template slot-scope="scope">
                                {{scope.row.sp_length?scope.row.sp_length:'-'}}
                            </template>
                        </el-table-column>
                        <el-table-column label="学费" width="80">
                            <template slot-scope="scope">
                                {{scope.row.tuition?scope.row.tuition:'-'}}
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                        background
                        layout="prev, pager, next, jumper"
                        :total="total" :page-size="30" @current-change="getSchoolAdvanceList" v-if="total > 0" :current-page.sync="form.page">
                    </el-pagination>
                </div>
            </template>
        </div>
    </div>
</template>
<script>
import { getPreBatch, getSchoolAdvance, getSearchAdvSchoolList } from "@/api/school"
import { mapState } from "vuex"

export default {

    name: 'toolsAdvance',

    data() {
        return {
            form: {
                local_type_id: '',
                zslx: '',
                scl_id: '',
                year: '',
                local_batch_id: '',
                page: 1,
                page_size: 30
            },
            batch_list: [],
            batch_obj: {},
            type_obj: {},
            subject_list: [],
            year_list: [],
            type_list: [],
            active_index: 0,
            active_index1: 0,
            loading: false,
            scl_ids: [],
            scl_pos: 0,
            zslx_ids: [],
            zslx_pos: 0,
            total: 0,
            school_list: [
                { value: "s1", label: "北京大学" },
                { value: "s3", label: "清华大学" },
                { value: "s17", label: "北京电子科技学院" },
                { value: "s24", label: "北京师范大学" },
                { value: "s2", label: "中国人民大学" },
            ],
            adv_list: [],
            show: false,
            rules: {
                year: [{
                    required: true
                }],
                local_type_id: [{
                    required: true
                }],
                local_batch_id: [{
                    required: true
                }]
            },
            has_code: 0
        }
    },
    computed: {
        ...mapState({
            function_code: state => state.user.function_code
        }),
    },
    watch: {
        function_code() {
            const tmp = this.function_code.filter(item => { return item.function_code === 'F00048'})
            if(tmp.length > 0) {
                this.has_code = tmp[0].has_code
            }
        }
    },
    mounted() {
        this.getPreBatchHandler()
        const tmp = this.function_code.filter(item => { return item.function_code === 'F00048'})
        if(tmp.length > 0) {
            this.has_code = tmp[0].has_code
        }
        
    },
    methods: {
        getPreBatchHandler() {
            let area = JSON.parse(localStorage.getItem('gkInforObj')).area || localStorage.getItem('area')
            getPreBatch({area:area}).then(res => {
                this.subject_list = res.data.local_type
                this.batch_list = res.data.local_batch
                this.year_list = res.data.year
                    this.batch_list.map(item => {
                    this.batch_obj[item.local_batch_id] = item.name
                })
                
                
                this.form.local_type_id = this.subject_list[0].local_type_id
                this.form.year = this.year_list[0].year
                this.form.local_batch_id = this.batch_list[0].local_batch_id
                this.type_list = this.batch_list[0].zslx
                this.type_list.map(item => {
                    this.type_obj[item.id] = item.name
                })
            })
        },
        getSchoolAdvanceSubmit() {
            if(this.has_code == 0) {
                this.$message({
                    message: '您的账户暂未开通此功能',
                    type: 'warning'
                })
                return
            }
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.scl_ids = []
                    this.pos = 0
                    this.zslx_ids = []
                    this.zslx_pos = 0
                    this.show = true
                    this.total = 0
                    this.adv_list = []
                    this.form.page = 1
                    this.getSchoolAdvanceList()
                }
            })

        },
        getSchoolAdvanceList() {
            this.scl_ids = []
            this.pos = 0
            this.zslx_ids = []
            this.zslx_pos = 0
            let area = JSON.parse(localStorage.getItem('gkInforObj')).area || localStorage.getItem('area')
            this.form.area = area
            // this.form.year = this.form.year || ''
            // this.form.local_type_id = this.form.local_type_id || ''
            getSchoolAdvance(this.form).then(res => {
                this.adv_list = res.data.data
                this.total = res.data.total
                res.data.data.forEach((element, index) => {
                    if (index === 0) {
                        this.scl_ids.push(1)
                        this.pos = 0
                        this.zslx_ids.push(1)
                        this.zslx_pos = 0
                    } else {
                    	if (element.scl_id === res.data.data[index - 1].scl_id) {
                    		this.scl_ids[this.pos] += 1
                            this.scl_ids.push(0)
                        } else {
                            this.scl_ids.push(1)
                            this.pos = index
                        }
                        if ((element.scl_id + element.zslx) === res.data.data[index - 1].scl_id + res.data.data[index - 1].zslx) {
                    		this.zslx_ids[this.zslx_pos] += 1
                            this.zslx_ids.push(0)
                        } else {
                            this.zslx_ids.push(1)
                            this.zslx_pos = index
                        }
                    }
                })
            })
        },
        changeSubject(index) {
            this.active_index = index
            this.form.local_type_id = this.subject_list[index].local_type_id
        },
        changeBatch(index) {
            this.type_list = {}
            this.form.zslx = ''
            this.active_index1 = index
            this.form.local_batch_id = this.batch_list[index].local_batch_id
            this.type_list = this.batch_list[index].zslx
            this.type_list.map(item => {
                this.type_obj[item.id] = item.name
            })
        },
        getSearchSchoolListHandler(query) {
            if (query == '') {
                return
            }
            this.loading = true;
            query.area = JSON.parse(localStorage.getItem('gkInforObj')).area || localStorage.getItem('area')
            getSearchAdvSchoolList(query).then(res => {
                this.loading = false;
                let list = [];
                list = res.data.map((item, index) => {
                    return { value: `${item.scl_id}`, label: `${item.scl_name}` };
                });
                this.school_list = list;
            })
        },
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 0) {
                let _row = this.scl_ids[rowIndex]
                let _col = _row > 0 ? 1 : 0
                return {
                    rowspan: _row,
                    colspan: _col
                }
            } else if (columnIndex === 1) {
                let _row = this.zslx_ids[rowIndex]
                let _col = _row > 0 ? 1 : 0
                return {
                    rowspan: _row,
                    colspan: _col
                }
            }
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/assets/css/variables.scss";

.adv-box {
    .adv-top-box {
        background: url('../../assets/images/advance_bg.png') no-repeat;
        height: 460px;
        background-position: center;
        background-size: cover;

        .adv-content-box {
            @include gwidth;
            img {
                margin-top: 56px;
                width: 292px;
            }
            h3 {
                font-size: 16px;
                color: rgba(51,46,44,0.50);
                margin: 12px 0 20px 0;
            }

            h4 {
                font-size: 20px;
                color: #332e2c;
                margin: 0;
            }
        }
    }

    .adv-frame-box {
        background: #ffffff;
        border-radius: 10px;
        backdrop-filter: blur(7px);
        @include gwidth;
        margin-top: -154px;
        padding: 24px;
        box-sizing: border-box;

        .adv-frame-title {
            font-size: 20px;
            font-weight: 600;
            color: #2c2e33;
            line-height: 28px;
            margin-bottom: 12px;

            span {
                display: inline-block;
                width: 3px;
                height: 20px;
                background: #1c9cff;;
                position: relative;
                top: 2px;
                margin-right: 10px;
            }
        }

        ::v-deep .adv-form-inline {
            background: #f7faff;
            border: 1px solid #e1e4eb;
            border-radius: 10px;
            padding: 24px 32px 32px 40px;
            margin-bottom: 32px;
            .el-select-dropdown__item.selected {
                color: #1c9cff !important;
            }
            .el-form-item {
                width: 50%;
                margin-right: 0;
            }

            .adv-form-item {
                .el-form-item__error {
                    margin-left: 180px;
                }
            }

            .el-form-item__label {
                font-size: 16px;
                color: #2c2e33;
                line-height: 52px;
                padding: 0;
            }

            .el-input {
                background: #ffffff;
                border: 1px solid #e1e4eb !important;
                border-radius: 8px;
                width: 397px;
                box-sizing: border-box;
            }

            .el-input__inner {
                border: none !important;
                height: 52px !important;
                line-height: 52px;
                border-radius: 8px;
                padding-right: 30px;
            }

            .el-input.is-disabled .el-input__inner {
                color: #332e2c !important;
            }

            .el-input__suffix {
                right: 10px;
            }

            .el-button+.el-button {
                margin-left: 16px;
            }

            .el-button,
            button {
                width: 160px;
                height: 52px;
                background: #ffffff !important;
                border: 1px solid #e1e4eb !important;
                border-radius: 8px;
                color: #5e6166 !important;
                font-size: 16px;
                text-align: center;
                padding: 0;
            }

            .active-batch {
                background: #f0f9ff !important;
                border: 1px solid #1c9cff !important;
                color: #1c9cff !important;
            }

            .adv-btn-diff {
                width: 72px !important;
            }

            .adv-input-diff {
                width: 221px !important;
                margin-left: 16px;
            }

            .adv-btn-submit {
                display: block;
                width: 240px !important;
                height: 50px !important;
                background: linear-gradient(90deg,#41c2ff, #1c9cff)!important;
                border-radius: 8px;
                border: none !important;
                text-align: center;
                font-size: 18px;
                color: #ffffff !important;
                position: relative;
                left: 50%;
                transform: translateX(-50%);
                margin-top: 10px;
            }
        }

    }
    .adv-title {
        color: #2c2e33;
        font-size: 14px;
        font-weight: 700;
    }
}

::v-deep {
    .school-detail-nav {
        .el-table{
            th {
                padding: 8px 12px;
            }
            td {
                padding: 8px 0 8px 12px;
            }
        }
        .cell {
            font-size: 14px;
        }
    }
    .el-pagination.is-background .el-pager li:not(.disabled).active {
        color: #1c9cff!important;
    }
}
</style>